import { createI18n } from 'vue-i18n';
import en from '../../lang/en.json';
import no from '../../lang/no.json';

const loadLocaleMessages = () => {
    // @todo: this is a workaround for the issue with the i18n module
    return {
        en,
        no
    };
    const locales = import.meta.globEager('../../lang/*.json');
    const messages = {};

    for (const key in locales) {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales[key];
        }
    }

    return messages;
};

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('locale') || 'no',
    fallbackLocale: 'en',
    messages: loadLocaleMessages()
});

export default i18n;
